import request from "./curl";
import utility from "./utility";
import iosBridge from './ios_bridge';
import chat_utility from "./chat_utility";
import media_utility from "./media_utility";
const Entities = require('html-entities').XmlEntities;
const entities = new Entities();

export default {
  name: 'chatgrp_list',
  data() {
    return {
      socket: this.$store.getters.getSocket,
      loading: true,
      title: 'chatgrp_list',
      data: [],
      group_participants: [],
      dialog: false,
      group_name_search: '',
      err_msg: '',
      snackbar: false,
      search_bar: false,
      chatContainerStyleObj: {},
      selectedGroupId: "",
      getUnreadGrp: {},
      group_icon_data:{},
      user_contact_list:{},
      invite_recieved: []
    }
  },
  async mounted() {
    this.chatContainerStyleObj = {
      'height': (this.getClientDeviceHeight - 104) + 'px',
      "padding": '0px',
    }

    //For Android Secure Permissions to Storage Folder
    if(window.androidBridge){
      this.getStoragePermissions();
    }
    
    //Get the FCM or APN Tokens
    this.chatuser_fcm_push_token_get();
    
    //If changing the $route.query.id here then also change it ion main.js & autologin.js
    let invitedGroupId = await this.invitedGroupId;
    if (invitedGroupId && (invitedGroupId != null || invitedGroupId != "null")) {
      await chat_utility.chatgrp_user_add(this, invitedGroupId);
    }
    else {
      this.get_groups();
    }
    await this.$store.commit("setInviteGroupId", null);//User Hs gt added to the group so now unset it

    this.getUnreadGrp = await this.getUnreadChatgrp;

    if(!this.getUnreadGrp) {
      this.getUnreadGrp = {};
    }

    await this.getUserContactList(); //Required for sockets
    this.user_contact_list = await this.getUserContactListLs;
    this.getInvites()
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    interests() {
      return this.$store.getters.userData.interests;
    },
    async selectedGroup() {
      this.selectedGroupId = await this.$store.getters.selectedGroup;
      let getUnreadChatgrp = await this.getUnreadChatgrp;
      //delete unread message
      if(getUnreadChatgrp && Object.keys(getUnreadChatgrp).length > 0){
        this.$delete(getUnreadChatgrp, this.selectedGroupId);
      }

      await this.$store.commit('setUnreadChatgrp', getUnreadChatgrp);
      return this.selectedGroupId;
    },
    async getChatgrpList() {
      return await this.$store.getters.getChatgrpList;
    },
    async getChatgrpIconList(){
      this.group_icon_data =  await this.$store.getters.getChatgrpIconList;
      if(this.group_icon_data == null){
        this.group_icon_data = {};
      }
      return this.group_icon_data ; 
    },
    async getUnreadChatgrp(){
      this.getUnreadGrp = await this.$store.getters.getUnreadChatgrp;
      return this.getUnreadGrp;
    },
    async invitedGroupId() {
      return await this.$store.getters.inviteGroupId;
    },
    fcm_push_token() {
      return this.$store.getters.fcm_push_token;
    },
    getSearchBar() {
      if (this.$store.getters.getSearchBar) {
        this.$nextTick(() => {
          this.$refs.search_text.focus();
        })
      }
      return this.$store.getters.getSearchBar;
    },
    getClientDeviceHeight() {
      return this.$store.getters.getClientDeviceHeight;
    },
    getListenerChatmsgAddResponse() {
      return this.$store.getters.getListenerChatmsgAddResponse;
    },
    getListenerChatgrpEditResponse() {
      return this.$store.getters.getListenerChatgrpEditResponse;
    },
    getListenerUserEditResponse() {
      return this.$store.getters.getListenerUserEditResponse;
    },
    filteredGroups() {
      if (this.data && this.data.length > 0) {
        let self = this;
        return this.data.filter(function (group) {
          //If Group Name is Missing or has a space then set default so that the App does not crash
          if (group.group_name == null || group.group_name.trim() == "") {
            group.group_name = "User X";
            group.group_icon = null;
          }

          if (group && group.group_id && group.group_name) {
            if (self.group_name_search) {
              return group.group_name.toLowerCase().indexOf(self.group_name_search.toLowerCase()) >= 0;
            }
            else {
              return group.group_name.toLowerCase();
            }
          }
        });
      }
    },
    async getUserContactListLs(){
      return await this.$store.getters.getUserContactList;
    },
    getRefreshChatGrpList() {
      return this.$store.getters.getRefreshChatGrpList;
    }
  },
  methods: {
    /**
     * getStoragePermissions
     *
     */
    async getStoragePermissions(counter=0){        
      let storagePerms = await window.androidBridge.checkAndRequestPermissions();
      if(storagePerms == "false" && counter <= 1){
        console.log("storagePerms", storagePerms, counter);
        setTimeout(() => {  
          this.getStoragePermissions(counter+1);
        }, 10000);  
      }
      else if(storagePerms == "false" && counter==2){
        this.$router.push('/warnings');
      }
    },
    /**
     * chatuser_fcm_push_token_get
     *
     */
    async chatuser_fcm_push_token_get(counter=0){
      let fcm_push_token = null;
      let device_id = "mweb";
      if(this.userData.user_id){
        //Always refresh the userid in Android Preferences. Because after logout and relogin, we need to set it back again

        if(window.androidBridge){          
          window.androidBridge.saveUserId(this.userData.user_id);        
          fcm_push_token = window.androidBridge.getFCMPushToken();          
          device_id = "android";
        }
        else if(window.webkit){
          iosBridge.sendMessage({"module":"saveUserId", "data":{"user_id":this.userData.user_id}});
          let fcm_push_token_obj = await iosBridge.sendMessage({ "module": "getFCMPushToken"})
          fcm_push_token = fcm_push_token_obj.data;
          device_id = "ios";
        }
        else{
          //For Web Push Notification
          device_id = "mweb";
          fcm_push_token = "";
        }
      }
  
      if(counter == 0 && (!fcm_push_token || fcm_push_token == "MESH00000")){
        //If fcm_push_token is not found immediately then try to get it again after 5sec
        setTimeout(() => {  
          counter = 1;
          this.chatuser_fcm_push_token_get(counter);            
        }, 5000);  
      }
      else{
        this.chatuser_fcm_push_token_update(device_id, fcm_push_token);
      }
  
      return fcm_push_token;
    },

    /**
     * chatuser_fcm_push_token_update
     *
     */
    chatuser_fcm_push_token_update(device_id, new_fcm_push_token) {
      //Save the Push token in Cache if Not same
      if (process.env.VUE_APP_DEBUG == "true") {console.log("chatuser_fcm_push_token_update: Old FCMToken=", this.fcm_push_token, "New FCM_Token=",new_fcm_push_token, "Device=", device_id);}

      if(!new_fcm_push_token || new_fcm_push_token.indexOf('null') !== -1){
        //Nothing to update
        return;
      }
          
      if(this.fcm_push_token && this.fcm_push_token == new_fcm_push_token
      ){
         //If Saved token and new token matches then dont update the backend
         return;
      }

      //Prep to update
      this.$store.commit("setFcmPushToken", new_fcm_push_token);
          
      console.log("chatuser_fcm_push_token_update: fcm_push_token: ", this.fcm_push_token);
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append('fcm_push_token', new_fcm_push_token);
      post_data.append('device_id', device_id);
      request.curl(this, "user_fcm_push_token_update", post_data);
    },
    /**
     * getUserContactList
     */
    async getUserContactList(){
      //Get for check local sforage has image checksum if have then sync it
      var user_contact_list_lf = await this.getUserContactListLs;
      if(user_contact_list_lf == null){
        user_contact_list_lf = {};
      }

      //sync image base64 if local forage have or not
      var user_image_base64 = null;
      if(user_contact_list_lf[this.userData.user_id]){
        user_image_base64 = (user_contact_list_lf[this.userData.user_id].user_image_base64) ? user_contact_list_lf[this.userData.user_id].user_image_base64 : null;
      } 

      let my_contact_list = {};
      my_contact_list[this.userData.user_id] = {
        user_id:this.userData.user_id,
        user_name:this.userData.user_name,
        image:this.userData.image,
        image_checksum: (this.userData.image_checksum) ? this.userData.image_checksum : null,
        user_image_base64: user_image_base64
      }

      var data = new FormData();
      data.append("chat_user_id", this.userData.user_id);

      request.curl(this, "user_contact_list", data).
      then(async response => {
        if(response.resp_status){
          let user_contact_list = response.resp_data;
          user_contact_list.forEach((contact) => {

            var contact_image_base64 = null;
            if(user_contact_list_lf[contact.contact_id]){
              contact_image_base64 = (user_contact_list_lf[contact.contact_id].user_image_base64) ? user_contact_list_lf[contact.contact_id].user_image_base64 : null
            }

            my_contact_list[contact.contact_id] = {
              user_id:contact.contact_id,
              user_name:contact.user_name,
              image: contact.image,
              image_checksum:contact.image_checksum,
              user_image_base64: contact_image_base64
            }
          });
        }
        await this.$store.commit('setUserContactList', my_contact_list);

        //Emit All Contact Id for a User for the connected socket          
        this.socket.emit('subscribe_contact_id_list', this.userData.user_id, my_contact_list);

        if(Object.keys(user_contact_list_lf).length <= 0){
          user_contact_list_lf = my_contact_list;
        }

        this.save_user_base64_thumbnails(my_contact_list, user_contact_list_lf);
      });
    },
    /**
     * save_user_base64_thumbnails()
     *
     */
    async save_user_base64_thumbnails(my_contact_list, user_contact_list_lf) {
      var uc_base64 = [];
      /* Check user have base64 image in your local forage check its checksum is diff if its diff then 
      / make new base64 image and put into localforgae
      */
      Object.keys(my_contact_list).forEach((uc_key)=>{
        var user_contact_lf = user_contact_list_lf[uc_key];
        var my_user_contact = my_contact_list[uc_key];

        if(user_contact_lf == undefined || Object.keys(user_contact_lf).length <= 0){ 
          //skip that user who is not found in localforage its come only first time or while he not stored in lf.
          return;
        }
        
        if(user_contact_lf.user_image_base64 == null 
        || (user_contact_lf.image_checksum != my_user_contact.image_checksum)){
          uc_base64.push(my_user_contact);
        }
      })
      
      //If all user have not checksum diff and have base64 then do not need to make base64
      if(uc_base64.length <= 0){
        return;
      }
      
      //Process for make base64 if User have not base64 and diff checksum
      var uc = uc_base64.map(async (ucl)=>{
        if(ucl.image){
          var base64_thumbnail = await media_utility.getBase64ImageThumbnail(ucl.image);
          if(base64_thumbnail){
            my_contact_list[ucl.user_id].user_image_base64 = base64_thumbnail;
            my_contact_list[ucl.user_id].image_checksum = ucl.image_checksum;
          }
        }

        return ucl;
      });
      
      await Promise.all(uc);
      await this.$store.commit('setUserContactList', my_contact_list);
    },
    /**
     * get_groups
     *
     */
    async get_groups() {
      this.group_icon_data = await this.getChatgrpIconList;
      
      //get chargrp list from localstorage first and render it
      let chatgrp_ls = await this.getChatgrpList;
      this.data = chatgrp_ls;

      this.loading = false;
      if (!chatgrp_ls) {
        this.loading = true;
      }
      
      this.get_groups_from_api(true);
    },
    /**
     * get_groups_from_api
     *
     */
    get_groups_from_api(direct_call) {
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);

      request.curl(this, "group_list", post_data)
      .then(async response => {
        if (response.resp_status) {
          let temp_object = response.resp_data;
          this.group_participants = response.resp_data_2;

          //Extract Messages from the Message List
          for (let index in response.resp_data_1) {
            let msg_obj = {};
            if (response.resp_data_1[index].group_id) {
              msg_obj = response.resp_data_1[index];
            }

            let temp_object_message_key = temp_object.findIndex((message) => {
              return message.group_id === msg_obj.group_id
            });

            if (temp_object[temp_object_message_key]) {
              temp_object[temp_object_message_key]['last_msg'] = (msg_obj['text_msg']) ? msg_obj['text_msg'] : '';
              temp_object[temp_object_message_key]['last_msg_sender'] = (msg_obj['sender_name']) ? msg_obj['sender_name'] : '';
              temp_object[temp_object_message_key]['last_message_id'] = (msg_obj['this_message_id']) ? msg_obj['this_message_id'] : '';
              temp_object[temp_object_message_key]['last_message_content_type'] = (msg_obj['message_content_type']) ? msg_obj['message_content_type'] : '';

              if (msg_obj['message_time']) {
                temp_object[temp_object_message_key]['last_msg_time'] = utility.get_message_datetime(msg_obj['message_time'], 'DD/MM/YYYY');
                temp_object[temp_object_message_key]['last_msg_ts'] = msg_obj['message_time'];
              }
              else {
                temp_object[temp_object_message_key]['last_msg_time'] = "--:--";
              }
            }
          }

          //Save the Group List
          let chatgrp_list = temp_object.sort(function (a, b) {
            if (a && b && a.last_msg_ts && b.last_msg_ts) {
              let x = b.last_msg_ts;
              let y = a.last_msg_ts;
              if (x < y) { return -1; }
              if (x > y) { return 1; }
              return 0;
            }

            return 0;
          });

          var my_group_ids = {};

          // Get all group_icon_data data 
          this.group_icon_data =  await this.getChatgrpIconList;
          if(this.group_icon_data == null){
            this.group_icon_data = {};
          }
          
          // Get all user contact list data 
          this.user_contact_list = await this.getUserContactListLf;
          if(this.user_contact_list == null){
            this.user_contact_list = {};
          }

          //In this variable fill all groups that have not icon checksum and or new checksum
          var base64_groups = []; 
          chatgrp_list.forEach((group) => {
            my_group_ids[group.group_id] = group.group_id;

            if (group.type == 0) {
              /*1-to-1 Message*/
              if (group.participants && group.participants != null) {
                let participant_ids = group.participants.split(',');
                participant_ids.forEach((participant_id) => {
                  if (participant_id !== this.userData.user_id) {
                    let participant = this.group_participants.find((participant) => { return participant.participant_id === participant_id });

                    if (participant) {
                      group.group_name = (participant.participant_name) ? participant.participant_name : 'User X';
                      var usr = {
                        user_id: participant.participant_id,
                        user_name: participant.participant_name,
                        image: participant.participant_image
                      }
                      
                      group.group_icon = this.get_user_icon(usr);
                    }
                    else {
                      group.group_name = 'User X';
                      group.group_icon = '';
                    }
                  }
                });
              }
            }
            else{
              /*  Get that groups which have not any checksum or if have that is new checksum
              *   After logout and login again its have all groups
              */
              if(this.group_icon_data[group.group_id] == undefined 
              || this.group_icon_data[group.group_id].group_icon_checksum != group.group_icon_checksum)
              {
                base64_groups.push(group);
              }
            }
          });
          
          //async process for make base64 icom if group have icon and not old checksum
          this.save_group_icons(base64_groups);

          //Emit All Group_ids for a User for the connected socket
          this.socket.emit('subscribe_group_id_list', this.userData.user_id, my_group_ids);

          //When a user switches device, then no data in LS. So if group not found in local storage populte from API Response
          if (!this.data || direct_call) {
            this.data = chatgrp_list;
          }
          
          //save groups to ls;
          await this.$store.commit('setChatgrpList', chatgrp_list);
        } 
        else {
          if (!await this.$store.getters.inviteGroupId) {
            //Only for New Registered Users, who came directly without any invite link
            console.log('No Groups Available');
            this.data = [];
            await this.$store.commit('setChatgrpList', null);
            this.$router.push("/home");
          }
        }        
        this.loading = false;
      });
    },

    /**
     * getInvites
     */
     getInvites() {
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append('invite_page', true)

      request.curl(this, "group_list", post_data)
      .then(async response => {
        if (response.resp_status) {
          this.invite_recieved = response.resp_data
          this.group_participants = response.resp_data_2;
          for (let group of this.invite_recieved) {
            if (group.type == 0) {
              /*1-to-1 Message*/
              if (group.participants && group.participants != null) {
                let participant_ids = group.participants.split(',');
                participant_ids.forEach((participant_id) => {
                  if (participant_id !== this.userData.user_id) {
                    let participant = this.group_participants.find((participant) => { return participant.participant_id === participant_id });

                    if (participant) {
                      group.group_name = (participant.participant_name) ? participant.participant_name : 'User X';
                      var usr = {
                        user_id: participant.participant_id,
                        user_name: participant.participant_name,
                        image: participant.participant_image
                      }
                      
                      group.group_icon = this.get_user_icon(usr);
                    }
                    else {
                      group.group_name = 'User X';
                      group.group_icon = '';
                    }
                  }
                });
              }
            }
          }
          this.$store.commit("seto2oInvite", this.invite_recieved);
        }
        else {
          this.$store.commit("seto2oInvite", []);
        }
      });
    },
    /**
    * save_group_icons
    */
    async save_group_icons(groups){
      if(groups.length <= 0){
        return;
      }
      
      var gps = groups.map(async (group)=>{
        this.group_icon_data[group.group_id] = {
          group_icon_checksum: group.group_icon_checksum,
          group_icon_base64: ''
        }
        
        if(group.group_icon){
          var base64_thumbnail = await media_utility.getBase64ImageThumbnail(group.group_icon);
          if(base64_thumbnail){
            this.group_icon_data[group.group_id].group_icon_base64 = base64_thumbnail;
          }
        }
        return group;
      });
      
      await Promise.all(gps);
      //save groups icon to ls
      await this.$store.commit('setChatgrpIconList', this.group_icon_data);
    },
    /**
     * get_formatted_name
     * Split on space and get the index0 of the name
     */
    get_formatted_name(grp_name) {
      let f_name = grp_name.substring(0, grp_name.indexOf(' '));
      if (!f_name) {
        return grp_name;
      }
      else {
        return f_name;
      }
    },
    /**
     * listen_for_group_details.
     * Pass the Group id to the function in group list, to listen on mysql
     */
    listen_for_edit_group_details(group) {
      let group_key = this.data.findIndex(g => {
        return g.group_id === group.groupInfo.group_id;
      });

      if (group_key !== false && group_key != '-1') {
        //keep last message, last message sender and time before override grpdetais and localstorage
        group.groupInfo.last_msg = this.data[group_key]['last_msg'] ? this.data[group_key]['last_msg'] : "";
        group.groupInfo.last_msg_sender = this.data[group_key]['last_msg_sender'];
        group.groupInfo.last_msg_time = this.data[group_key]['last_msg_time'];
        group.groupInfo.last_msg_ts = this.data[group_key]['last_msg_ts'];
        this.$set(this.data, group_key, group.groupInfo);
      }
    },
    /**
     * removeFromGroup.
     * //Participant user get out from Group details and chat page when it will remove from group
     */
    removeFromGroup(diff) {
      Object.keys(diff).forEach(async (key) => {
        //diff group details
        let grp_details = {};
        let chatgrpList = await this.getChatgrpList;
        let grp_details_index = chatgrpList.findIndex(group => group.group_id === key);
        if (grp_details_index != '-1') {
          grp_details = chatgrpList[grp_details_index];
        }

        //snack bar should be globally now it will be show chat group details and chat message if group remove
        let snackbar = {};
        this.err_msg = "You have been removed from the group " + grp_details.group_name + " by the group admin";
        this.snackbar = snackbar.show = true;
        this.$store.commit('setSnackBar', snackbar);
        if (this.$router.currentRoute.name != 'chat_content') {
          if (key == await this.selectedGroup) {
            setTimeout(() => {
              this.$router.push('/chat');
            }, 3000);
          }
        }
      });
    },
    /**
     * select_group.
     * select clicked group and set it to selected group in the store
     */
    async select_group(group) {
      await this.$store.commit("setSelectedGroup", group.group_id);
      this.$store.commit("setSearchBar", false);
      this.$router.push('chat_message');
    },
    /**
     * get_colored_name.
     */
    get_colored_name(name, keyword = '') {
      if (keyword === '') {
        keyword = this.group_name_search;
      }
      let index = name.toLowerCase().indexOf(keyword.toLowerCase());
      let f_name = name.substring(0, index);
      let color_name = '<span class="theme-color">' + name.substring(index, index + keyword.length) + '</span>';
      let l_name = name.substring(index + keyword.length);
      return f_name + color_name + l_name.substring(0, 20);
    },
    /**
     * add_msg_to_relevant.
     * add new received msg from listener to relevant messages if it has "#"
     */
    add_msg_to_relevant(msg) {
      let msg_key = Object.keys(msg);
      if (msg[msg_key].text_msg.includes("#")) {
        let index = msg[msg_key].text_msg.toLowerCase().indexOf('#');
        let after_tag = msg[msg_key].text_msg.substring(index + 1);
        let interest_wo_hash = after_tag.split(" ");

        if (!interest_wo_hash[0]) {
          return false;
        }

        msg[msg_key].c_text_msg = this.get_colored_name(msg[msg_key].text_msg, interest_wo_hash[0]);

        if (this.userData.interests) {
          if (!this.userData.interests.includes('#' + interest_wo_hash[0])) {
            this.userData.interests += ',#' + interest_wo_hash[0];
          }
        }
        else {
          this.userData.interests = '#' + interest_wo_hash[0];
        }

        this.$store.commit('setUserProfile', this.userData);

        var post_data = new FormData();
        post_data.append('chat_user_id', this.userData.user_id);
        post_data.append('interests', this.userData.interests);
        request.curl(this, "chatuser_edit", post_data)
          .then(response => {
            console.log(response);
          });
      }
    },
    /**
     * gChatgrp_move_to_top
     * Watch on the latest message, to be displayed in chat group list and shift to top
     */
    async gChatgrp_move_to_top(msg) {
      let msgIndex = Object.keys(msg);

      let getUnreadChatgrp = await this.getUnreadChatgrp;

      let unread_chatgrp = (getUnreadChatgrp) ? getUnreadChatgrp : {};

      //Find the index of the group list in which the message has to be rendered
      if (this.data.length > 0) {
        let index = this.data.findIndex(x => x && x.group_id && x.group_id === msg[msgIndex]['group_id']);

        if (this.data[index] != undefined) {
          let last_message_time = (this.data[index]['last_msg_ts']) ? this.data[index]['last_msg_ts'] : 0;
          if (msg[msgIndex]['message_time'] > last_message_time) {
            let grp = this.data[index];//Get the group obj

            grp['last_msg'] = msg[msgIndex]['text_msg'];
            grp['last_msg_sender'] = msg[msgIndex]['sender_name'];
            grp['last_message_id'] = (msg[msgIndex]['this_message_id']) ? msg[msgIndex]['this_message_id'] : '';
            grp['last_message_content_type'] = (msg[msgIndex]['message_content_type']) ? msg[msgIndex]['message_content_type'] : '';

            grp['last_msg_time'] = utility.get_message_datetime(msg[msgIndex]['message_time'], 'DD/MM/YYYY');

            //Only add to unread if sent by another user
            if(msg[msgIndex]['sender_id'] != this.userData.user_id) {
              unread_chatgrp[grp.group_id] = true;

              //This is done to show the yellow dot on first message received after login.
              //Because of some reason computed property does not work on first message after login.
              this.getUnreadGrp =  unread_chatgrp;

              await this.$store.commit('setUnreadChatgrp', unread_chatgrp);
            }

            //Remove the group from its current index and move it on top
            this.data.splice(index, 1);
            this.data.unshift(grp);
            await this.$store.commit('setChatgrpList', this.data);
            //TODO:- Evaluate and Implement for mWeb
            //this.add_msg_to_relevant(msg) vinay
          }
        }
      }
    },
    /**
     * hideSearchBar
     * 
     */
    hideSearchBar() {
      this.$store.commit('setSearchBar', false);
    },
    /**
    * replaceUserIdMicro 
    * User tag with user name by user id for mention user
    */
   async replaceUserIdMicro(message, tagStrArr){
      var user_contact_list = await this.getUserContactListLs;
      return utility.replaceUserIdMicro(message, tagStrArr, user_contact_list, false);
    },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    },
    /*
    * get_group_icon
    * */
    get_group_icon(group, group_icon_data){
      return media_utility.get_group_icon(group, group_icon_data);
    },
    /*
    * get_user_icon
    * */
    get_user_icon(user){
      var user_icon = media_utility.get_user_icon(user, this.user_contact_list);
      return user_icon;
    }
  },
  watch: {
    /**
     * getRefreshChatGrpList
     */
    getRefreshChatGrpList(refreshFlag){
      this.get_groups_from_api(refreshFlag);
    },
    /**
      * getChatgrpList
      */
    getChatgrpList: async function (groups) {
      this.data = await groups;
    },
    /**
     * getListenerChatmsgAddResponse
     */
    getListenerChatmsgAddResponse(message) {
      //move group at top when new message come from listner
      this.gChatgrp_move_to_top(message);
    },
    /**
    * getListenerChatgrpEditResponse
    */
    getListenerChatgrpEditResponse(group) {
      this.listen_for_edit_group_details(group);
    },
    /**
     * getListenerUserEditResponse
     */
    getListenerUserEditResponse(user) {
      if (user.user_id != this.userData.user_id) {
        this.data.forEach((group, key) => {
          //check for group type one to one and change group name as participant
          if (group.type == 0) {
            if (group.participants && group.participants != null) {
              let participants = group.participants.split(',');
              participants.forEach((participant_id) => {
                if (participant_id === user.user_id) {
                  this.data[key].group_name = user.user_name;
                  if (user.image) {
                    this.data[key].group_icon = user.image;
                  }
                }
              })
            }
          }
        })
      }
    }
  },
  directives: {
    plaintext:async function(el, binding, vnode){ 
      let gp_details = binding.value;
      let last_msg = '';

      //get last message id
      let last_message_id = '';
      if(gp_details.coloured_last_msg){
        last_msg = gp_details.coloured_last_msg;
      }
      else{
        last_msg = gp_details.last_msg;
      }
      
      last_msg = entities.encode(last_msg);

      let last_message_content_type = '';
      
      if(gp_details && gp_details.last_message_id){
        last_message_id = gp_details.last_message_id;
        last_message_content_type = gp_details.last_message_content_type;
      }

      //Format media type
      if(last_message_id){ 
        if(last_message_content_type == 1){//1 is media message
          el.innerHTML = "";
          let icon = media_utility.listingMediaMessageFormat(last_msg);
          el.appendChild(icon);
          last_msg = el.innerHTML;
        }
      }
      
      var tagStrArr = utility.getUserTags(last_msg);
      if(tagStrArr){
        last_msg = await vnode.context.replaceUserIdMicro(last_msg, tagStrArr);
      }
      el.innerHTML = last_msg;
    }
  }
}
